import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import history from '../../../../route/history'
import CertboxForm1 from './form/CertboxForm1'
import CertboxForm2 from './form/CertboxForm2'
import CertboxForm3 from './form/CertboxForm3'
import CertboxForm5 from './form/CertboxForm5'
// import CertboxForm6 from './form/CertboxForm6'
import CertboxForm21 from './form/CertboxForm21'
import { alertActions, authActions, certboxActions } from '../../../../store/actions'
import { commons } from '../../../../hook/common'
import * as Common from '../../../../assets/js/common.js'

const CertboxDetail = (props) => {
  const queryString = require('query-string')

  const [state, setState] = useState({
    isToggle: false,
  })
  const [historyInfo, setHistoryInfo] = useState({})
  const [certboxInfo, setcertboxInfo] = useState({})
  const [certboxTransSts, setcertboxTransSts] = useState('')
  const [crtNm, setCrtNm] = useState('')

  useEffect(() => {
    const locationInfo = props.location.state

    setHistoryInfo({
      ...historyInfo,
      selectedSubject: locationInfo?.selectedSubject,
      tabStatus: locationInfo?.tabStatus,
      searchWord: locationInfo?.searchWord,
      srhFrom: locationInfo?.srhFrom,
      srhTo: locationInfo?.srhTo,
      srhKind: locationInfo?.srhKind,
      pageIdx: locationInfo?.pageIdx || 0,
    })

    if (props.match.params.seq) {
      let crtSeq = props.match.params.seq
      props.getcertboxInfo(crtSeq)
    }
  }, [])

  useEffect(() => {
    if (props.certboxInfo) {
      setcertboxInfo(props.certboxInfo)
      setcertboxTransSts(props.certboxInfo?.transSts)
      if (props.certboxInfo?.crtCd === '01') {
        setCrtNm('구매확인서')
      } else if (props.certboxInfo?.crtCd === '02') {
        setCrtNm('간접수출증명서')
      } else if (props.certboxInfo?.crtCd === '03') {
        setCrtNm('시험성적서')
      } else if (props.certboxInfo?.crtCd === '05') {
        setCrtNm('안전확인 신고서')
      // } else if (props.certboxInfo?.crtCd === '06') {
      //   setCrtNm('거래명세서')
      } else if (props.certboxInfo?.crtCd === '21') {
        setCrtNm('전자계약문서')
      }
      console.log('crtCd', props.certboxInfo?.crtCd)
    }
  }, [props.certboxInfo])

  useEffect(() => {
    if (props.isDelete) {
      // 수신함 삭제 성공
      goList()
    } else {
      // 변경 실패
    }
  }, [props.isDelete])

  useEffect(() => {
    if (props.isFailure) {
      // 수신함 조회 실패시 데이터 초기화
      setcertboxInfo({})
    }
  }, [props.isFailure])

  useEffect(() => {}, [props.isSubDoc])

  const goList = () => {
    // e.preventDefault()

    let paramStr = queryString.stringify(historyInfo)
    paramStr.length > 0 && (paramStr = '?' + paramStr)

    if (props.location.state?.isHelp === undefined) {
      console.log('props.location.state?.isHelp === undefined')
      window.location.replace('/service/certbox' + paramStr)
    } else {
      console.log('isHelp', props.location.state?.isHelp)
      window.location.replace('/service/sent' + paramStr)
    }
  }

  const onPDFView = () => {
    const fileList = props.certboxInfo?.fileNewList

    if (!fileList || !fileList.length) {
      props.error({ message: 'PDF 파일이 존재하지 않습니다.' })
      return
    }

    fileList.forEach((val, idx, arr) => {
      setTimeout(() => {
        let url = process.env.REACT_APP_API_URL + '/portal/file/edms/' + fileList[idx].contentId
        console.log(url)
        let xhr = new XMLHttpRequest()
        xhr.responseType = 'blob'
        xhr.onload = function () {
          /*
	          let _anchor = document.createElement('a');
	          _anchor.href = window.URL.createObjectURL(xhr.response); // xhr.response is a blob
	          _anchor.download = val['originFileNm']; // Set the file name.
	          _anchor.style.display = 'none';
	          document.body.appendChild(_anchor);
	          _anchor.click();
	          document.body.removeChild(_anchor);
	          const file = new File([(xhr.response)], val['originFileNm'])
	          window.open('/pdfViewer/pdfViewer.html?file=' + file, '_blank');
	          */
          if (Common.getDeviceType() === 'MobileApp' || Common.getDeviceType() === 'MobileWeb') {
            window.M.execute(
              'exWNStartViewPDFActivity',
              process.env.REACT_APP_API_URL + '/pdfViewer/pdfViewer.html?file=' + window.URL.createObjectURL(xhr.response),
            )
          } else {
            console.log(window.URL.createObjectURL(xhr.response))
            window.open('/pdfViewer/pdfViewer.html?file=' + window.URL.createObjectURL(xhr.response), '_blank')
          }
        }
        xhr.open('GET', url)
        xhr.send()
      }, 1000)
    })
  }

  // const onSubmit = () => {
  //   history.push({ pathname: '/service/certbox/submit', state: certboxInfo })
  // }

  // const onDelete = () => {
  //   props.deletecertbox({ crtRcvSeq: certboxInfo?.crtRcvSeq })
  // }

  // const onDropDown = () => {
  //   setState({
  //     ...state,
  //     isToggle: !state.isToggle,
  //   })
  // }

   // window.onpopstate = function (event) {
   //   goList()
   // }

  return (
    <>
      {/* contents */}
      <div id="contents">
        <div className="content-header">
          <a href="#" className="page-prev" onClick={goList}>
            이전페이지로 이동
          </a>
          {/* mobile */}
          <h2>{crtNm}</h2>
          <div className="breadcrumb">
            <span>Home</span>
            <span>전자문서지갑</span>
            <em>{crtNm}</em>
          </div>
        </div>
        {certboxInfo?.crtCd === '01' && <CertboxForm1 data={certboxInfo} goList={goList}/>}
        {certboxInfo?.crtCd === '02' && <CertboxForm2 data={certboxInfo} goList={goList}/>}
        {certboxInfo?.crtCd === '03' && <CertboxForm3 data={certboxInfo} goList={goList}/>}
        {certboxInfo?.crtCd === '05' && <CertboxForm5 data={certboxInfo} goList={goList}/>}
        {/*{certboxInfo?.crtCd === '06' && <CertboxForm6 data={certboxInfo} goList={goList}/>}*/}
        {certboxInfo?.crtCd === '21' && <CertboxForm21 data={certboxInfo} goList={goList}/>}
        {certboxInfo?.crtCd === '01' && (
          <div className="guide-box gray mt20">
            <dl className="dlist1">
              <dt>구매확인서 문서 보존기간은 발급일자 기준 1년 입니다.</dt>
            </dl>
          </div>
        )}
        {certboxInfo?.crtCd === '02' && (
          <div className="guide-box gray mt20">
            <dl className="dlist1">
              <dt>간접수출 증명서 문서 보존기간은 발급일자 기준 1년 입니다.</dt>
            </dl>
          </div>
        )}
      </div>
      {/* //contents */}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    certboxList: state.certbox?.certboxList?.list,
    certboxInfo: state.certbox?.certboxInfo,
    isDelete: state.certbox?.isDelete,
    pdfString: state.certbox?.pdfString,
    isFailure: state.certbox?.isFailure,
    isSubDoc: state.certbox?.isSubDoc,
  }
}

const actionCreators = {
  getcertboxInfo: certboxActions.getcertboxInfo,
  deletecertbox: certboxActions.deletecertboxList,
  success: alertActions.success,
  error: alertActions.error,
  getCurrentUser: authActions.getCurrentUser,
  initPdfFlag: certboxActions.initPdfFlag,
  subcertboxDocPdf: certboxActions.subcertboxDocPdf,
}

export default connect(mapStateToProps, actionCreators)(CertboxDetail)
